import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Barcode from 'react-barcode';

@inject('ticketStore')
@observer
export default class BarcodeItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      barcodeList: []
    }

    const {
      ticketStore: {
        getBarcodeList,
      },
    } = this.props;

    this.state.barcodeList = getBarcodeList();
  }

  renderOrderStateName = (item) => {
    const {
      orderState,
      orderStateNm,
    } = item;

    if (orderState === 'E') {
      return (
        <div key={item}>
          <span className="txt-state txt-used">{orderStateNm}</span>
        </div>
      )
    }

    if (orderState === 'A') {
      return (
        <span className="txt-state txt-used">{orderStateNm}</span>
      )
    }

    if (orderState !== 'A' && orderState !== 'E') {
      return (
        <span className="txt-state txt-fail">{orderStateNm}</span>
      )
    }

    return null;
  }

  createMarkup = (markupContent) => {
    return { __html: markupContent }
  }

  renderBarcodes(groupNm, items) {
    return _.map(items, (item) => {
        const { 
          itemNm,
          pin,
          orderState,
          ticketStatus: {
            usable: ticketUsable,
            message
          }
        } = item;

        const isUsableTicket = orderState === 'E' && ticketUsable;
        if (!isUsableTicket) {
          if(ticketUsable && orderState !== 'E') {
            return (
              <div className="item-content item-barcode item-log" key={pin}>
                <label>
                  <input type="checkbox" disabled />
                  <span className="icon-chk" />
                  <span className="txt-chk">{itemNm}</span>
                  <span className="txt-pincode">핀번호 : {pin}</span> 
                </label>
                <div>{this.renderOrderStateName(item)}</div>
              </div>
            )
          } else {
            return (
              <div className="item-content item-barcode" key={pin}>
                <div className="text-content" dangerouslySetInnerHTML={this.createMarkup(message)} />
              </div>
            )
          }
        };

        return (
          <div className="item-content item-barcode" key={pin}>
            <span className="txt-name">{itemNm}</span>
            <Barcode value={pin} width={1} height={100} className="img-barcode" />
            <div>{this.renderOrderStateName(item)}</div>
          </div>
        );
    });
  }

  render() {
    const {
      groupNm,
      items,
    } = this.props;

    return (
      <div className="box-item" key={groupNm}>
        <h3 className="item-title">{groupNm}</h3>
        {this.renderBarcodes(groupNm, items)}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/TicketBarcodeItems.jsx